import { Board, StickerDesignId, PaymentMethodId } from '../utils/Primitives';
import { Address } from 'viem';
import { useWriteContract } from 'wagmi';
import { abi } from './StickerDesignsAbi';
import { getPaymentMethod } from '../payments/PaymentMethods';

const StickerContractAddress = process.env.NEXT_PUBLIC_STICKER_DESIGNS_CONTRACT_ADDRESS as `0x${string}` | null;

export function useStickerContract() {
  const { writeContract } = useWriteContract();

  const capSticker = (stickerId: StickerDesignId) => {
    if (!StickerContractAddress) {
      throw new Error('No Sticker Contract Address');
    }

    return writeContract({
      abi,
      address: StickerContractAddress,
      functionName: 'capSticker',
      args: [BigInt(stickerId)],
    });
  };

  const setStickerLimitToHolders = (stickerId: StickerDesignId, limitToHolders: Address) => {
    if (!StickerContractAddress) {
      throw new Error('No Sticker Contract Address');
    }

    return writeContract({
      abi,
      address: StickerContractAddress,
      functionName: 'setStickerLimitToHolders',
      args: [BigInt(stickerId), limitToHolders],
    });
  };

  const setStickerPrice = (stickerId: StickerDesignId, price: number, paymentMethodId: PaymentMethodId, boardRef: React.MutableRefObject<Board>) => {
    if (!StickerContractAddress) {
      throw new Error('No Sticker Contract Address');
    }

    const paymentMethod = getPaymentMethod({ boardRef, paymentMethodId });
    if (!paymentMethod) {
      throw new Error('Payment method not found');
    }

    // Convert the price to the appropriate integer value based on token decimals
    const priceInWei: bigint = BigInt(Math.floor(price * Math.pow(10, paymentMethod.decimals)));
    return writeContract({
      abi,
      address: StickerContractAddress,
      functionName: 'setStickerPrice',
      args: [BigInt(stickerId), BigInt(paymentMethodId), priceInWei],
    });
  };

  return {
    capSticker,
    setStickerLimitToHolders,
    setStickerPrice,
  };
}